import { Helmet } from "react-helmet-async";
import { BrowserRouter } from "react-router-dom";
import { Spin } from "antd";
import { useSelector } from "react-redux";
import AuthenticatedApp from "./authenticatedApp";
import PublicApp from "./publicApp";
import OnboardingContactPage from "./publicApp/OnboardingContactPage";
import { useTranslation } from "react-i18next";
import { useAuth } from "../contexts/auth";
import AuthProvider from "../contexts/auth";
import CartProvider from "../contexts/cart";

const PUBLIC_ROUTES = ["/privacy-policy", "/recovery", "/onboarding-contact", "/resetPassword", "/verifyAccount"];

const Router = () => {
  const auth = useAuth();
  const authenticated = !!auth.loggedInUser || auth.isSSO;
  const redirectPayload = useSelector(state => state.auth?.redirectPayload);

  // While checking authentication or initializing Keycloak
  if (auth.checkingForLoggedInUser || !auth.isKeycloakReady) {
    return (
      <div
        style={{
          height: "100vh",
          width: "100vw",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  // Onboarding required — render directly, no redirect needed
  if (redirectPayload) {
    return <OnboardingContactPage />;
  }

  // Show PublicApp if on any public route (e.g. direct URL visit)
  const currentPath = window.location.pathname;
  if (PUBLIC_ROUTES.some(route => currentPath === route || currentPath.startsWith(route + "/"))) {
    return <PublicApp />;
  }

  // User is authenticated
  if (authenticated) {
    return <AuthenticatedApp />;
  }

  // User is not authenticated - show public pages (login, password reset, etc)
  return <PublicApp />;
};

function App() {
  const { i18n } = useTranslation();
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <Helmet
            titleTemplate="%s - FoodLabz"
            defaultTitle="FoodLabz"
            htmlAttributes={{ lang: i18n.language }}
          >
            <meta name="description" content="FoodLabz" />
          </Helmet>
          <Router />
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
